import { CardHistoricoProps } from "../../Base/types";
import CardHistoricoBase from "../../Base/CardHistoricoBase";
import { FileX, LucideIcon } from "lucide-react";
import ExpandedContent from "../AnexoAdicionado/ExpandedContent";

const detectaAnexoRemovido = (acao: string): boolean => {
    const acaoLower = acao.toLowerCase().trim();
    return acaoLower.includes('removeu anexo');
};

const getIconAnexoRemovido = (acao: string): { Icon: LucideIcon; color: string } => {
    return { Icon: FileX, color: 'var(--ce5293f)' };
};

export default function CardAnexoRemovido({ item, onNavigateToFile, isExpanded, onToggleExpand }: CardHistoricoProps) {
    return (
        <CardHistoricoBase
            item={item}
            icon={getIconAnexoRemovido(item.acao)}
            temExpansaoDisponivel={true}
            isExpanded={isExpanded}
            onToggleExpand={onToggleExpand}
            expandedContent={<ExpandedContent item={item} onNavigateToFile={onNavigateToFile} />}
            tituloCustomizado="Anexo removido"
        />
    );
}

export const anexoRemovidoConfig = {
    tipo: 'anexo_removido',
    detectaTipo: detectaAnexoRemovido,
    getIcon: getIconAnexoRemovido,
    temExpansao: () => true,
    Component: CardAnexoRemovido
};

